import { Relation } from '@cotera/era';
import { DataGridModel } from './model';
import {
  useGetOrCreateArtifact,
  CacheResult,
} from '@cotera/client/app/etc/data/artifacts';
import { useMemo } from 'react';

export const ArtifactLoader = ({
  rel,
  children,
  modelFactory,
  cacheKey,
}: {
  rel: Relation;
  children: (model: DataGridModel) => React.ReactNode;
  modelFactory: (artifact: CacheResult) => DataGridModel;
  cacheKey: string;
}) => {
  const { data: artifact } = useGetOrCreateArtifact({
    rel,
  });

  const model = useMemo(() => {
    return modelFactory(artifact);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cacheKey]);

  return children(model);
};
